import { CustomFilterWithGrid } from 'components/CustomTableFilter';
import { useRequest } from 'features/request/useRequest';

import { useMemo } from 'react';

import { getOtherToWorkOrderChangePriceList } from '../WorkOrderChangeQueries';

export const useAddOtherToWorkOrderChangeFilterConfig = ({
    workOrderChangeId,
    constructionTypeId,
}: {
    workOrderChangeId: number;
    constructionTypeId: number;
}) => {
    const variables = useMemo(
        () => ({
            workOrderChangeId,
            constructionTypeId,
        }),
        [constructionTypeId, workOrderChangeId],
    );

    const [workOrderChangeFilterData, , , workOrderChangeFilterRequest] = useRequest({
        requestId: 'addOtherFilters',
        withEffect: false,
        query: getOtherToWorkOrderChangePriceList,
    });

    return useMemo(
        () =>
            [
                {
                    id: 'name',
                    name: 'Наименование: ',
                    field: 'name',
                    filterer: () => true,
                    component: {
                        name: CustomFilterWithGrid,
                        props: {
                            items: workOrderChangeFilterData?.uerWorkOrderChangeOtherListQuery?.items,
                            requestFn: workOrderChangeFilterRequest,
                            requestQuery: getOtherToWorkOrderChangePriceList,
                            dataAccessor: 'workOrderChangeOtherListQuery',
                            requestVariables: variables,
                            childFieldAccessor: 'name',
                            columnDefs: [
                                {
                                    checkboxSelection: true,
                                    headerName: 'Наименование',
                                    field: 'name',
                                    lockVisible: true,
                                    flex: 1,
                                },
                            ],
                            whereVariables: ['name'],
                        },
                    },
                },
            ] as any,
        [variables, workOrderChangeFilterData?.uerWorkOrderChangeOtherListQuery?.items, workOrderChangeFilterRequest],
    );
};
